export  default {
    setLogRequests(state, payload) {
        state.logRequests = payload;
    },
};